<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ courseName }}</BreadcrumbItem>
      <BreadcrumbItem>习题答疑</BreadcrumbItem>
    </Breadcrumb>
    <div class="container clearfix">
      <div class="fl question-wrap">
        <div class="question-subject">
          <div class="question-statics">
            题目
            <span class="fr">
              共
              <b class="color1">{{ questionCount }}</b> 个提问
            </span>
          </div>
          <practice-item
            ref="practiceItem"
            :data="exerInfo"
            :index="-1"
            v-model="exerInfo.userKey"
            practiceType="discuss"
          ></practice-item>
        </div>
        <div class="question-list">
          <question-list
            @on-loadFinish="setQuestionCount"
            v-if="updateList"
            questionType="exer"
          ></question-list>
        </div>
      </div>
      <div class="fr question-side">
        <question-ask
          @on-success="submitSuccess"
          :umcId="umcId"
          :position="position"
          :fromId="fromId"
          :fromPosition="fromPosition"
        ></question-ask>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
import QuestionAsk from "../../components/exercise/QuestionAsk";
import QuestionList from "../../components/exercise/QuestionList";
import PracticeItem from "../../components/exercise/PracticeItem";
export default {
  mixins: [siteMixin],
  data() {
    return {
      courseName: "",
      exerInfo: {},
      updateList: true,
      questionCount: 0,
      position: "cat",
      fromId: 0,
      fromPosition: "",
    };
  },
  created() {
    if (!this.initParams() || !this.posParams()) return;
    this.getCourseName();
    this.getExerciseInfo();
    this.setMetaData("习题答疑");
  },
  methods: {
    initParams() {
      let exerId = this.$route.params.id;
      let umcId = this.$route.query.umcid;
      //console.log(exerId, umcId);
      if (umcId && exerId) {
        this.setUmcId(umcId);
        this.setPptId(0);
        this.setExerId(exerId);
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    posParams() {
      //用于提问路径的参数
      const catId = this.$route.query.catid;
      const regId = this.$route.query.regid;
      const simId = this.$route.query.simid;
      const from = this.$route.query.from;
      if (!catId && !regId && !simId && !from) {
        this.$Message.error("参数错误");
        return false;
      }
      if (from && from != "wrong" && from != "fav") {
        this.$Message.error("来源错误");
        return false;
      }
      if (catId) {
        this.position = "cat";
        this.fromId = Number(catId);
      }
      if (regId) {
        this.position = "reg";
        this.fromId = Number(regId);
      }
      if (simId) {
        this.position = "sim";
        this.fromId = Number(simId);
      }
      if (from) {
        this.position = from;
      }
      return true;
    },
    getExerciseInfo() {
      study.getExerciseInfo(this.exerId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.exerInfo = res.data;
          this.$set(this.exerInfo, "userKey", this.exerInfo.rightKey);
          this.$set(this.exerInfo, "doResult", 1);
        }
      });
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then((res) => {
        if (res.status === 1) {
          this.courseName = res.data.courseName;
          if (this.position == "wrong" || this.position == "fav") {
            this.fromPosition = this.courseName;
          }
        }
      });
    },
    setQuestionCount(questionList) {
      this.questionCount = questionList.length;
    },
    submitSuccess() {
      //console.log("ask-success");
      this.updateList = false;
      this.$nextTick(() => {
        this.updateList = true;
      });
    },
  },
  components: {
    QuestionAsk,
    QuestionList,
    PracticeItem,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/question.less";
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.question-wrap {
  width: 860px;
  padding-bottom: 2rem;
  .question-subject {
    margin-bottom: 2rem;
  }
}

.question-list {
  border: 2px solid #e6e6e6;
  padding: 30px 30px 10px 30px;
}

.question-side {
  width: 320px;
  background: #fff;
  padding: 10px 20px 10px 20px;
  border: 2px solid #e6e6e6;
}
</style>